var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Training50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M19.9 31.7H32.599999999999994V33.7H19.9z",
    transform: "rotate(-64.437 26.249 32.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M30.7 26.4H32.7V39.099999999999994H30.7z",
    transform: "rotate(-25.565 31.745 32.748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M28,6h2v27h-2V6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M15,9h28v21H15V9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M22 38.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S24.3 40 23.5 40 22 39.3 22 38.5M33 38.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S35.3 40 34.5 40 33 39.3 33 38.5M14 8h30v4H14V8zM14 29h30v2H14V29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M11,14c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S13.2,14,11,14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M24,19H11c-1.1,0-2-0.9-2-2s0.9-2,2-2h13c1.1,0,2,0.9,2,2S25.1,19,24,19z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M4,22v7l2.6,1.8L7.5,42h7L16,19c0,0-1.1-4-5-4S4,18.1,4,22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d81b60",
    d: "M35 17h3v9h-3V17zM31 20h3v6h-3V20zM27 22h3v4h-3V22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Training50);
export default __webpack_public_path__ + "static/media/icons8-training-50.810339b4e6bf16e79deaadca7c143456.svg";
export { ForwardRef as ReactComponent };